import { FC, useEffect, useState, useRef} from "react";
import { Link, useLocation } from 'react-router-dom';

import styles from './styles.module.scss'
import { Logo } from "shared/ui/logo";
import { useMobileMenuContext } from "shared/contexts/mobile-menu-context";

let prevScrollpos = 0;

export const Header: FC = () => {
    const [top, setTop] = useState(0);
    const location = useLocation();
    const { isMobileMenuOpen, isMobile, toggleMobileMenu } = useMobileMenuContext();
    const headRef = useRef<HTMLDivElement>(null);

    useEffect(() => {
        const handleScroll = () => {
            if (!headRef.current) return;

            const pos = window.scrollY;

            if (prevScrollpos > pos || pos < 50) {
                setTop(0);
            } else {
                setTop(-80);
            }
            prevScrollpos = pos;
        };

        window.addEventListener("scroll", handleScroll);
        return () => window.removeEventListener("scroll", handleScroll);
    }, []);

    const isEducationInfoPage = location.pathname === '/education-info';

    return (
        <>
            <div className={`${styles.before} a11y-before`} />

            <div
                className={`${styles.header} a11y-header`}
                ref={headRef}
                style={{ top: top }}
            >
                <div className={styles.__in}>

                    <div className={styles.logo}>
                        <Link to="/">
                            <Logo />
                        </Link>
                    </div>

                    {/* Показываем либо кнопку меню, либо навигацию */}
                    {isEducationInfoPage && isMobile ? (
                        <button 
                            className={`${styles.mobileMenuButton} ${isMobileMenuOpen ? styles.menuOpen : ''}`}
                            onClick={toggleMobileMenu}
                            data-mobile-menu-button
                            aria-label={isMobileMenuOpen ? "Закрыть меню" : "Открыть меню"}
                        >
                            <div className={styles.menuIcon}>
                                <span className={styles.hamburgerLine}></span>
                                <span className={styles.hamburgerLine}></span>
                                <span className={styles.hamburgerLine}></span>
                            </div>
                        </button>
                    ) : (
                        <div className={styles.menu}>
                            <Link to="/education-info">
                                <div className={styles.li}>
                                    <span>Сведения об организации</span>
                                </div>
                            </Link>
                            {!isEducationInfoPage && (
                                <>
                                    <a href="#get">
                                        <div className={styles.li}>
                                            <span>Обучение</span>
                                        </div>
                                    </a>
                                    <a href="#courses">
                                        <div className={styles.li}>
                                            <span>Направления</span>
                                        </div>
                                    </a>
                                    <a href="#process">
                                        <div className={styles.li}>
                                            <span>Для кого</span>
                                        </div>
                                    </a>
                                    <a href="#feedback">
                                        <div className={styles.li}>
                                            <span>Поступить</span>
                                        </div>
                                    </a>
                                    <a href="#teachers">
                                        <div className={styles.li}>
                                            <span>Преподаватели</span>
                                        </div>
                                    </a>
                                    <a href="#contacts">
                                        <div className={styles.li}>
                                            <span>Контакты</span>
                                        </div>
                                    </a>
                                </>
                            )}
                        </div>
                    )}

                </div>

            </div>
        </>
    );
};